import { render, staticRenderFns } from "./MFAValidationModal.vue?vue&type=template&id=673afc47&scoped=true"
import script from "./MFAValidationModal.vue?vue&type=script&lang=js"
export * from "./MFAValidationModal.vue?vue&type=script&lang=js"
import style0 from "./MFAValidationModal.vue?vue&type=style&index=0&id=673afc47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673afc47",
  null
  
)

export default component.exports